<template>
  <div id="auth">
    <div v-if="loading" id="preloader">
      <div class="lds-circle"><div></div></div>
    </div>
    <div v-else>
      <transition appear name="slide-fade">
        <div>
          <!-- Page Content -->
          <div class="page-content">
            <!-- Banner -->
            <div class="banner-wrapper shape-1">
              <div class="container inner-wrapper">
                <img src="assets/images/logo/logo-xs.png" class="mx-auto" />
                <h2 class="dz-title mt-4">Escanea el QR</h2>
                <p class="mb-0">
                  Registra tu visita a uno de nuestros aliados y obtiene
                  beneficios.
                </p>
              </div>
            </div>
            <!-- Banner End -->
            <div class="container">
              <div class="account-area">
                <transition appear name="slide-fade">
                  <qrcode-stream @decode="on_decode"></qrcode-stream>
                </transition>
              </div>
            </div>
          </div>
          <!-- Page Content End -->
          <!-- Footer -->
          <footer class="footer fixed">
            <div class="container">
              <router-link
                to="/"
                class="btn btn-primary light btn-rounded text-primary d-block"
                >Cancelar</router-link
              >
              
              <div class="mb-3">
                <qrcode-capture class="form-control form-control-lg form-custom" @decode="on_decode" id="formFileLg"/>
              </div>
            </div>
          </footer>
          <!-- Footer End -->
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "Leer_qr",
  metaInfo: {
    title: "Registra tu visita - Reddy App",
  },
  data() {
    return {
      loading: true,
      session: null,
      usuario: null,
    };
  },
  created: function () {
    var session = localStorage.getItem("sess_reddy_app");
    if (session == undefined) {
      this.$router.push("/auth");
    } else {
      session = JSON.parse(session);
      this.session = session;
      this.usuario = session.usuario;
    }
  },
  methods: {
    on_decode(code) {
      this.loading = true;
      navigator.geolocation.getCurrentPosition(
        (position) => {
          console.log(position.coords.latitude);
          console.log(position.coords.longitude);
        },
        (error) => {
          console.log(error.message);
        }
      );
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
        params: {
          code: code,
        },
      };
      const vm = this;
      axios
        .get(this.$base_url + "aliados/aliado_code", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$router.push("/error_leer_qr");
          } else {
            var aliado_qr = {
              token: response.data.data.token_aliado,
              id_aliado:response.data.data.id_aliado,
              aliado: response.data.data.nombre_aliado,
            };
            localStorage.setItem("aliado_qr", JSON.stringify(aliado_qr));
            vm.$router.push("/feedback");
          }
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "<i class='fa fa-exclamation-circle'></i> Ups!",
              text: error,
            }),
          (vm.loading = false)
        )
        .finally();
    },
  },
  mounted: function () {
    this.loading = false;
  },
};
</script>